import { ChangeDetectorRef, Component, Input, Output, TemplateRef, ViewChild, ViewEncapsulation, EventEmitter } from '@angular/core';
import { WeekDay, MonthViewDay, ViewPeriod } from 'calendar-utils';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarMonthViewDay,
  CalendarView,
  DAYS_OF_WEEK
} from 'angular-calendar';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  green: {
    primary: '#00b2ac',
    secondary: '#FAE3E3',
  },
  yellow: {
    primary: '#000',
    secondary: '#FDF1BA',
  },
};
const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"];

import { ECR } from '../models/ecr';
import { ECRService } from '../service/ecr.service';
import {
  subMonths,
  addMonths,
  addDays,
  addWeeks,
  subDays,
  subWeeks,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  isFuture,
} from 'date-fns';

export interface CalendarMonthViewBeforeRenderEvent {
  header: WeekDay[];
  body: MonthViewDay[];
  period: ViewPeriod;
}
type CalendarPeriod = 'day' | 'week' | 'month';
function addPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
  return {
    day: addDays,
    week: addWeeks,
    month: addMonths,
  }[period](date, amount);
}

function subPeriod(period: CalendarPeriod, date: Date, amount: number): Date {
  return {
    day: subDays,
    week: subWeeks,
    month: subMonths,
  }[period](date, amount);
}

function startOfPeriod(period: CalendarPeriod, date: Date): Date {
  return {
    day: startOfDay,
    week: startOfWeek,
    month: startOfMonth,
  }[period](date);
}

function endOfPeriod(period: CalendarPeriod, date: Date): Date {
  return {
    day: endOfDay,
    week: endOfWeek,
    month: endOfMonth,
  }[period](date);
}

@Component({
  selector: 'app-ecr-calendar-view',
  templateUrl: './ecr-calendar-view.component.html',
  styleUrls: ['./ecr-calendar-view.component.css'],
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      h3 {
        margin: 0 0 10px;
      }
 
      pre {
        background-color: #f5f5f5;
        padding: 15px;
      }
      .red-cell {
        background-color: red !important;
      }
      .blue-cell {
        background-color: blue !important;
      }
    `,
  ],
})

export class EcrCalendarViewComponent {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;
  minDate: Date = new Date;
  maxDate: Date = new Date;
  pendingEcrs: number = 0;
  holidays: number = 0;
  workingDays: number = 0;
  missedEcrDays: number;
  holidayDate: any;
  holidaysTillDate: any[] = [];

  private _employee;
  private _branchCode: string;
  @Input()
  set employee(value: any) {
    if (value) {
      this.pendingEcrs = 0;
      this.ECRMonth = value.ecrMonth;
      this.ECRYear = value.ecrYear;
      this.viewDate = new Date(this.ECRYear, value.ecrMonth - 1);
      this.minDate = new Date(value.date_of_joining);
      this.maxDate = value.date_of_exit ? new Date(value.date_of_exit) : new Date;
      // this.workingDays = value.WorkingDays;
      this._employee = value;
      this.events = [];
      this.getEmployeeDetails(value.tmc_id);
      this.getReportingHeadDetails(value.tmc_id);
      this.EcRModel.TMCNo = value.tmc_id;
      this.getECRByTMCAndMonth();
    }
  }
  get employee() {
    return this._employee;
  }

  @Output() employeeDOJ = new EventEmitter<string>();

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  ECRList: ECR[] = [];
  EcRModel: ECR = new ECR();
  EmailList: any[] = [];
  holidayList: any[] = [];
  checkList: any[] = [];
  ECRMonth: number;
  ECRYear: number;
  modalData: {
    action: string;
    event: CalendarEvent;
  };

  excludeDays: number[] = [0, 6];
  weekStartsOn = DAYS_OF_WEEK.SUNDAY;
  refresh = new Subject<void>();
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = true;
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  constructor(private _ecrService: ECRService, private _cdr: ChangeDetectorRef) { }

  refreshView(): void {
    this.refresh.next();
  }

  dayClicked(events): void {
    this.viewDate = events.day.date;
    if (events.day.events.length > 0) {
      if (!events.day.events[0].meta)
        this.getECRDetails(this.ECRList.filter(ecr => ecr.ECRId === events.day.events[0].id)[0]);
      else {
        this.EmailList = [];
        this.holidayList = [];
        events.day.events.forEach(e => this.holidayList.push(e.title));
      }
    } else {
      this.EmailList = [];
      this.holidayList = [];
    }
  }

  beforeMonthViewRender(renderEvent: CalendarMonthViewBeforeRenderEvent): void {
    let today = -1;
    //const monthCell = document.querySelector('mwl-calendar-month-cell');

    renderEvent.body.forEach((e, i) => {
      if (e.isToday) {
        today = i;
        return;
      }
    })
    if (today > -1) {
      if (!renderEvent.body[today - 1].isWeekend && renderEvent.body[today - 1].events.length === 0) {
        renderEvent.body[today - 1].cssClass = 'pending-ecr';
      }
      if (!renderEvent.body[today - 2].isWeekend && renderEvent.body[today - 2].events.length === 0) {
        renderEvent.body[today - 2].cssClass = 'pending-ecr';
      }
      this.getPendingEcrs();
    }
    renderEvent.body.forEach((day) => {
      if (day.isWeekend) day.cssClass = 'weekend';
      if (day.events) {
        day.events.map(e => {
          if (e.meta && e.meta.type === "holiday") {
            day.cssClass = "holiday";
          }
        });
      }
    });
  }

  getPendingEcrs() {
    this.pendingEcrs = document.getElementsByClassName('pending-ecr').length;
    return this.pendingEcrs;
  }

  getEmployeeDetails(TmcNo: string) {
    this._ecrService.GetEmployeeInformation(TmcNo).subscribe(
      data => {
        this.EcRModel.FromEmail = data.Data.Company_E_Mail;
        this.EcRModel.EmployeeName = data.Data.Full_Name;
        // this.minDate = moment(data.Data.Date_of_Joining).toDate();
        this._branchCode = data.Data.Branch;
        this.fetchHolidays();
        this.employeeDOJ.emit(data.Data.Date_of_Joining);
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  private fetchHolidays() {
    this._ecrService.getHolidays(this._branchCode, this.ECRYear.toString(), MONTHS[this.ECRMonth - 1]).subscribe(data => {
      if (data.length > 0) {
        this.checkList = data;
        this.holidays = data.length;
        data.map((holiday) => {
          if (new Date(holiday.Date) < new Date()) {
            this.holidaysTillDate.push(new Date(holiday.Date));
          }
          this.events = [...this.events];
          this.events.push({
            start: new Date(holiday.Date),
            title: holiday.Description,
            allDay: true,
            color: colors.yellow,
            meta: {
              type: 'holiday',
              holiday,
            },
          });
        });
        this.workingDays = this.getWorkingDays();
        this.missedEcrDays = this.getMissedEcrsDays();
      } else {
        this.checkList = [];
        this.holidaysTillDate = [];
      }
    });
  }

  getReportingHeadDetails(TmcNo: string) {
    this._ecrService.GetReportingHeadDetails(TmcNo).subscribe(
      data => {
        // this.EcRModel.OtherEmail=data.OtherEmail;
        this.EcRModel.ToEmail = data.Data.Company_E_Mail;
        // this.EcRModel.ToEmail=data.CompaneyEmail;
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  getECRByTMCAndMonth() {
    this._ecrService.GetECRByTMCAndMonthCalender(this.EcRModel.TMCNo, this.ECRMonth, this.ECRYear).subscribe(
      data => {
        this.events = [];
        this.fetchHolidays();
        if (data.Status && data.Data.length > 0) {
          data.Data.forEach((item) => {
            this.events.push({
              id: item.ECRId,
              start: new Date(item.ECRDate),
              end: new Date(item.ECRDate),
              title: `ECR for ${item.ECRDate}`,
              color: colors.green
            })
          });
          this.viewDate = new Date(data.Data[0].ECRDate);
          this.ECRList = data.Data;
          this.getECRDetails(this.ECRList[0]);
        } else if (data.Data.length === 0) {
          this.EmailList = [];
          this.ECRList = [];
        }
      },
      error => {
        console.error(error);
      }, () => {
        this.refreshView();
      }
    );

  }

  getECRByTMC() {
    this._ecrService.GetECRByTMC(this.EcRModel.TMCNo).subscribe(
      data => {
        //console.log(data);
        if (data.Status) {
          this.ECRList = data.Data;
        }
        else { }
      },
      error => {
        console.log(error);
        console.error();
      }
    );
  }

  getECRDetails(item: any) {
    this.EmailList = item.OtherEmail.split(",");
    this.EcRModel.ECRId = item.ECRId;
    this.EcRModel.ECRSubject = item.ECRSubject;
    this.EcRModel.ECRDetails = item.ECRDetails;
    this.EcRModel.EcrDate = item.ECRDate;
    // this.getECRDocs(item.TMCNo, this.EcRModel.EcrDate);
  }

  increment(): void {
    this.holidays = 0;
    this.pendingEcrs = 0;
    this.missedEcrDays = 0;
    this.changeDate(addPeriod(this.view, this.viewDate, 1));
  }

  decrement(): void {
    this.holidays = 0;
    this.pendingEcrs = 0;
    this.missedEcrDays = 0;
    this.changeDate(subPeriod(this.view, this.viewDate, 1));
  }

  today(): void {
    this.changeDate(new Date());
  }

  dateIsValid(date: Date): boolean {
    return date >= this.minDate && date <= this.maxDate;
  }

  changeDate(date: Date): void {
    this.viewDate = date;
    this.dateOrViewChanged();
  }

  dateOrViewChanged(): void {
    this.ECRMonth = this.viewDate.getMonth() + 1;
    this.ECRYear = this.viewDate.getFullYear()
    this.getECRByTMCAndMonth();
    this.prevBtnDisabled = !this.dateIsValid(
      endOfPeriod(this.view, subPeriod(this.view, this.viewDate, 1))
    );
    this.nextBtnDisabled = !this.dateIsValid(
      startOfPeriod(this.view, addPeriod(this.view, this.viewDate, 1))
    );
    if (this.viewDate < this.minDate) {
      this.changeDate(this.minDate);
    } else if (this.viewDate > this.maxDate) {
      this.changeDate(this.maxDate);
    }
  }

  isCurrentMonth(month): boolean {
    return new Date().getMonth() + 1 === month;
  }

  daysInMonth(month, year) {
    let days = new Date(year, month, 0).getDate();
    return days;
  }

  daysInMonthTillToday(month, year) {
    let today = new Date();
    let dd = today.toString();
    let ddNameArray = dd.split(' ');
    return Number(ddNameArray[2]) - 1;
  }

  isWeekdayTillDate(year, month, day) {
    let d = new Date(year, month - 1, day).getDay();
    return d != 0 && d != 6 && new Date() > new Date(year, month - 1, day);
  }

  getWeekdaysInMonth(month: number, year: number) {
    let days = this.isCurrentMonth(month) ? this.daysInMonthTillToday(month, year) : this.daysInMonth(month, year);
    let weekdays = 0;
    for (let i = 1; i <= days; i++) {
      if (this.isWeekdayTillDate(year, month, i)) {
        weekdays++;
      }
    }
    return weekdays;
  }

  getMissedEcrsDays(): number {
    // console.log("Weekdays - ",this.getWeekdaysInMonth(this.ECRMonth, this.ECRYear));
    // console.log("Ecrlength - ",this.ECRList.length);
    // console.log("pendingEcrs - ",this.pendingEcrs);
    // console.log("Weekday HOlidays - ",this.getWeekdayHolidayCountPastMonth(this.ECRMonth));
    return this.getWeekdaysInMonth(this.ECRMonth, this.ECRYear) - this.ECRList.length - this.pendingEcrs - this.holidays;
  }

  //#region Working days calculations
  isWeekday(year, month, day) {
    let isTrue = true;
    let d = new Date(year, month, day);
    let daysNoName = d.toString();
    let dayNameArray = daysNoName.split('');
    if (dayNameArray[0] == 'S') {
      isTrue = false;
      return isTrue;
    } else {
      return isTrue;
    }
  }

  getWeekdayInMonth(month: number, year: number) {
    let days = this.daysInMonth(month, year);
    let weekdays = 0;
    for (let i = 1; i <= days; i++) {
      if (this.isWeekday(year, month - 1, i)) {
        weekdays++;
      }
    }
    return weekdays;
  }

  getWorkingDays(): any {
    return this.getWeekdayInMonth(this.ECRMonth, this.ECRYear) - this.getWeekdayHolidayCount(this.ECRMonth);
  }

  getWeekdayHolidayCount(month: number): number {
    return this.checkList.filter(h => {
      const d = new Date(h.Date);
      return this.isWeekday(d.getFullYear(), d.getMonth(), d.getDate());
    }
    ).length;
  }
  //#endregion

  getWeekdayHolidayCountPastMonth(month: number): number {
    return this.holidaysTillDate.filter(h => {
      const d = h;
      console.log("value of h is - ", h)
      return this.isWeekdayTillDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
      // if (this.isCurrentMonth(month)) {
      //   return this.isWeekdayTillDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
      // } else {
      //   return this.isWeekday(d.getFullYear(), d.getMonth(), d.getDate());
      // }
    }).length;
  }
}

